module.exports = __webpack_public_path__ + "static/media/blurnid.cbdad471.png";